import React from 'react';
import PropTypes from 'prop-types';

function CustomDashboard({ ctaAction }) {
  return (
    <div className="mt-custom-dashboard">
      <div className="mt-custom-dashboard__background"></div>
      <div className="mt-row">
        <div className="mt-column mt-column--dark">
          <div className="mt-custom-dashboard__content">
            <h2>Build your custom dashboard</h2>
            <p className="mt-strapline">
              To stay in control and make the best strategic decisions you need
              to follow our two-step process.
            </p>
            <h3>Step 1 - connect</h3>
            <p>
              Each of the applications we connect to has a simple step by step
              process with instructions on how to get up and running in seconds.
            </p>
            <h3>Step 2 - customise</h3>
            <p>
              The tiles that present your business information are customisable
              by you. Drag and drop them, pick dates and values. Keep the
              dashboard the way you want it.
            </p>
            <button
              onClick={ctaAction}
              className="mt-button mt-button--secondary"
              aria-label="Get started (build your custom dashboard)"
            >
              Get started
            </button>
          </div>
          <div className="mt-custom-dashboard__image">
            <picture>
              <source
                media="(min-width: 576px)"
                srcSet="../images/vm/m-track/dashboard-screenshot-large@2x.png 2x,
              ../images/vm/m-track/dashboard-screenshot-large@1x.png 1x"
              />
              <source
                srcSet="../images/vm/m-track/dashboard-screenshot-small@2x.png 2x,
              ../images/vm/m-track/dashboard-screenshot-small@1x.png 1x"
              />
              <img
                alt="M-Track Dashboard Screenshot"
                src="../images/vm/m-track/dashboard-screenshot-large@1x.png"
                srcSet="../images/vm/m-track/dashboard-screenshot-large@1x.png 1x, ../images/vm/m-track/dashboard-screenshot-large@2x.png 2x"
              />
            </picture>
          </div>
        </div>
        <div className="mt-column">
          <div className="mt-custom-dashboard__content">
            <h2>Giving you more control</h2>
            <dl className="mt-checklist">
              <dt>Make better decisions</dt>
              <dd>See your key business data all in one place.</dd>
              <dt>Explore great articles</dt>
              <dd>Access expertise from our business network.</dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
}

CustomDashboard.propTypes = {
  ctaAction: PropTypes.func.isRequired,
};

export { CustomDashboard };
